require("normalize.css/normalize.css");
require("./styles/index.scss");

import Mouse from "./utils/mouse";
import SimplexNoise from "./utils/SimplexNoise"

const noise = new SimplexNoise()

const canvas = document.querySelector(".main-canvas");
canvas.width = window.innerWidth * window.devicePixelRatio;
canvas.height = window.innerHeight * window.devicePixelRatio;

const ctx = canvas.getContext("2d");

let mouseX, mouseY;
let time = 0

const update = () => {
  requestAnimationFrame(update);

  time += 0.00075

  mouseX = ((Mouse.cursor[0] + 1) / 2) * canvas.width;
  mouseY = ((Mouse.cursor[1] + 1) / 2) * canvas.height;

  let steps = 100
  let frequency = 0.005

  ctx.save()
  ctx.translate(0, 0)

  ctx.fillStyle = '#0a0a0a'
  ctx.globalAlpha = 1
  ctx.fillRect(0, 0, canvas.width, canvas.height)
  ctx.globalAlpha = .15
  for (let i = 0; i < steps; i++) {

    for (let j = 0; j < steps; j++) {
      ctx.strokeStyle = '#ff000f'
      ctx.beginPath()
      ctx.lineTo(noise.noise2D((j * frequency) + i + time, time * 2) * 1000 + canvas.width / 2, i / j * canvas.height)
      ctx.lineTo(noise.noise2D((j * frequency) + i + time, time / 2) * 1000 + canvas.width / 2, i / j * canvas.height - 400)

      ctx.stroke()
      ctx.closePath()
    }

    for (let j = 0; j < steps; j++) {
      ctx.strokeStyle = '#0f00ff'
      ctx.beginPath()
      ctx.lineTo(- noise.noise2D((j * frequency) + i + time, time * 2) * 1000 + canvas.width / 2, i / j * canvas.height)
      ctx.lineTo(- noise.noise2D((j * frequency) + i + time, time / 2) * 1000 + canvas.width / 2, i / j * canvas.height - 400)

      ctx.stroke()
      ctx.closePath()
    }
  }
  ctx.restore()
};

requestAnimationFrame(update);
